export const colors = {
  primary: '#FF4500',         // oranje/red accent
  background: '#F9F9F9',      // lichtgrijs achtergrond
  backgroundPage: '#FFFFFF',  // pagina achtergrond
  text: '#333333',             // standaard tekst
  textLight: '#555555',        // lichtere tekst voor links
  button: '#FF6347',           // buttons
  buttonHover: '#FF4500',
};